import { defineComponent as _defineComponent } from 'vue'
import { externalURLS } from '@/router/routes/urlRoutes'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import { useAuthStore } from '@/stores/auth/useAuthStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpCenterCardComponent',
  setup(__props) {

const { t } = useI18n()
const text = {
  courses: t('components.dialog.support_service.help_center.courses'),
  frecuentQuestions: t('components.dialog.support_service.help_center.frequent_questions'),
  manuals: t('components.dialog.support_service.help_center.manuals'),
  title: t('components.dialog.support_service.help_center.title'),
  videos: t('components.dialog.support_service.help_center.videos')
}

const authStore = useAuthStore()

const encryptedUserId = computed<string>(() => authStore.encryptedUserId)

const urls = computed(() => {
  const encryptedUserIdValue = encryptedUserId.value
  return {
    courses: `${ externalURLS.courses }${ encryptedUserIdValue }`,
    faqs: `${ externalURLS.faqs }${ encryptedUserIdValue }`,
    helpCenterEmail: externalURLS.help_center_email,
    manuals: `${ externalURLS.manuals }${ encryptedUserIdValue }`,
    helpCenter: `${ externalURLS.help_center }${ encryptedUserIdValue }`,
    videos: `${ externalURLS.videos }${ encryptedUserIdValue }`
  }
})

const helpWidgets = computed(() => {
  return [
    {
      text: text.frecuentQuestions,
      url: urls.value.faqs
    },
    {
      text: text.videos,
      url: urls.value.videos
    },
    {
      text: text.manuals,
      url: urls.value.manuals
    },
    {
      text: text.courses,
      url: urls.value.courses
    }
  ]
})

return { __sfc: true,t, text, authStore, encryptedUserId, urls, helpWidgets }
}

})